import moment from 'moment';

/**
 * Generates a valid UUID v4 (random UUID)
 * Format: xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx
 * where x is any hexadecimal digit and y is one of 8, 9, A, or B
 * @returns {string} A valid UUID v4 string
 */
export function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function isValidPhoneNumber(phonenumber) {
  // Regex to check valid
  // International Phone Numbers
  let regex = /^\+[0-9]{1,3}(?:[\s.-]?[0-9]{1,3}){1,2}[0-9]{4,14}$/;
  return regex.test(phonenumber);
}

export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function removeUnderScoreAndMakeEveryFirstLetterCapital(string) {
  let word = string.replace(/_/g, ' ');
  const arr = word.split(' ');

  for (var i = 0; i < arr.length; i++) {
    arr[i] = capitalizeFirstLetter(arr[i]);
  }

  return arr.join(' ');
}
export function formatDate(date) {
  return moment(date).format('MMMM Do YYYY');
}

export function formatDateWithTime(date) {
  return date ? moment(date).format('MMMM Do  h:mm a') : null;
}

export function isValidUUID(uuid) {
  const uuidRegex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return uuidRegex.test(uuid);
}

export function mergeArray(oldArray = [], newArray = []) {
  const arrayDic = {};
  oldArray.forEach((item) => (arrayDic[item.id] = item));
  newArray.forEach((item) => (arrayDic[item.id] = item));
  return Object.values(arrayDic);
}
export const formatConditionalNumber = (num) => {
  return Number.isInteger(num) ? num : num.toFixed(2);
};

export function formatRetailerId(value) {
  let formattedValue = String(value)
    .replace(/\s+/g, '_') // Replace spaces with underscores
    .replace(/[^a-zA-Z0-9_]/g, '') // Remove any non-alphanumeric characters except underscores
    .toLowerCase(); // Convert to lowercase for case sensitivity consistency

  // Truncate to the maximum character limit of 80 if needed
  if (formattedValue.length > 80) {
    formattedValue = formattedValue.slice(0, 100);
  }

  // Append a timestamp to ensure uniqueness
  return `${formattedValue}_${new Date().getTime()}`;
}
